import { ReactNode } from 'react'
import { useParams } from 'react-router-dom'

import { useAgents } from '@hooks/use-agents'
import { useUser } from '@hooks/use-user';

import { ConditionalLayout } from './ConditionalLayout'

interface AgentLayoutProps {
    children: ReactNode
}

export function AgentLayout({ children }: AgentLayoutProps) {
    const { slug } = useParams<{ slug: string }>()
    const { getAgent, loading: agentsLoading } = useAgents()
    const { isAuthenticated, loading: userLoading } = useUser()


    const agent = getAgent(slug || '')

    // Custom not found content for agents
    const agentNotFoundContent = (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <h1 className="text-2xl font-bold mb-4">Agent Not Found</h1>
                <p>The requested agent could not be found or is not available.</p>
            </div>
        </div>
    )

    return (
        <ConditionalLayout
            requireAuth={() => !agent?.public} // Require auth if agent is not public
            fallbackToLogin={true} // Redirect to login if auth required but not authenticated
            minimalLayout={agent?.public && !isAuthenticated} // Use minimal layout for public agents
            isLoading={agentsLoading || userLoading}
            isNotFound={!agentsLoading && !agent}
            notFoundContent={agentNotFoundContent}
        >
            {children}
        </ConditionalLayout>
    )
}